<template>
  <v-skeleton-loader
    :loading="isLoading"
    type="text"
    v-intersect.once="{
      handler: onIntersect,
      options: {
        threshold: [0, 0.5, 1.0]
      }
    }">
    <div class="d-flex flex-column gap-1 yard-area-presenter" style="min-width: 50px">
      <span
        :class="size === 'small' ? 'typography-body-sm' : 'typography-body-md'"
        data-testid="yard-area-presenter-area-name">
        {{ areaName || '-' }}
      </span>
    </div>
  </v-skeleton-loader>
</template>

<script>
import { defineComponent, toRefs } from 'vue';

import { useYardAreaPresenter } from './useYardAreaPresenter';

export default defineComponent({
  name: 'YardAreaPresenter',
  props: {
    size: {
      type: String,
      required: false,
      default: 'regular',
      validator(value) {
        return ['regular', 'small'].includes(value);
      }
    },
    area: {
      type: Object,
      required: false,
      default: null
    },
    areaId: {
      type: String,
      required: false,
      default: null
    }
  },
  setup(props) {
    const { areaId, area } = toRefs(props);

    const { currentArea, areaName, isLoading, refresh } = useYardAreaPresenter(
      { areaId, area },
      true
    );

    const onIntersect = () => {
      refresh();
    };

    return {
      currentArea,
      areaName,
      isLoading,
      onIntersect
    };
  }
});
</script>

<style scoped>
:deep(.v-skeleton-loader__text) {
  /** this value makes the loader have the same vertical spacing as the area name text */
  margin: 6px 0 !important;
}
</style>
